'use client';

import Icon from '@/components/ui/AppIcon';

const ContactHero = () => {
  return (
    <section className="relative py-16 lg:py-24 bg-gradient-to-br from-primary via-secondary to-ocean overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-72 h-72 bg-accent rounded-full blur-3xl" />
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-sky-blue rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl mb-6">
          <Icon name="ChatBubbleLeftRightIcon" size={40} className="text-white" />
        </div>
        
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-white mb-6">
          Contact & Support Hub
        </h1>
        
        <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto mb-8">
          Get immediate assistance from our UK-based travel experts. Available 24/7 through multiple channels.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-6 text-white/80">
          <div className="flex items-center gap-2">
            <Icon name="ClockIcon" size={20} className="text-accent" />
            <span className="text-sm font-bold">24/7 Support</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="ChatBubbleLeftIcon" size={20} className="text-accent" />
            <span className="text-sm font-bold">AI-Powered Chat</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="MapPinIcon" size={20} className="text-accent" />
            <span className="text-sm font-bold">UK Office</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;